import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
import ouibounce from 'ouibounce'
import 'jqueryui'

import {getCookie, is_mobile, setCookie, Utils} from '../utils';
import {ServiceWorkerSetup} from '../../static/push/sw-setup';
import DataLayerService from 'datalayer-service/src/datalayer';
import {CashbackCodeAction, PromoType} from "datalayer-service/src/types/enums";


window.gb = window.gb || {};
window.gb.AUX_COOKIE_AGE = 30 * 24 * 60 * 60 * 1000;

// FIXME: Fix "Bug with sticky modal pop-up in Explorer <= 11"
// * https://app.asana.com/0/1267016837188/179423791245555
const is_ie10_or_ie11 = navigator.userAgent.match(/Trident\/[67]\./);
const use_mobile_version = is_mobile || is_ie10_or_ie11;
const dataLayerService = new DataLayerService(window);

// Serialize form data to JSON.
// - http://stackoverflow.com/a/22420377/236169
$.fn.serializeObject = function () {
  let o = {}, a = this.serializeArray();

  $.each(a, function () {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || undefined);
    } else {
      o[this.name] = this.value || undefined;
    }
  });
  return o;
};


const PROMO_CLOSE_ICON_CLASS = "promo-close-icon";
const REBATE_POPUP_MODAL_ID = "rebate-popup-modal";
const REBATE_POPUP_MODAL_OPEN_CLASS = "rebate-popup-modal-open";

const rebatePopupModalIcon = function (isCollapsed, parent = `#${REBATE_POPUP_MODAL_ID}`, isV1Popup = false) {
  const popupModalHeader = $(`${parent} .modal-header`)
  const icon = $(`${parent} .${PROMO_CLOSE_ICON_CLASS}`);

  if (isV1Popup) {
    icon.toggleClass('visible', isCollapsed);
    popupModalHeader.toggleClass('not-clickable', !isCollapsed);
  }

  if (!isCollapsed) {
    icon.removeClass('fa-plus');
    icon.addClass('fa-minus');
  } else {
    icon.removeClass('fa-minus');
    icon.addClass('fa-plus');
  }
}

const PromoBoxHandler = function (options) {
  let exports = {}, djs = Utils.datajs;

  $.extend(exports, {
    init: function (options) {
      this.options = options;
      this.TIMER = "timer";
      this.DISABLED = "true";
      this.trigger_states = [this.DISABLED, this.TIMER];
      this.cookie_prefix = this.options.cookie_prefix || "";
      this.timespent_cookie_name = this.cookie_prefix + "_timespent";
      this.sync_cookie_name = this.cookie_prefix + "_sync";
      this.pages_cookie_name = this.cookie_prefix + "_pages";
      this.cookie_age = this.options.cookie_age;
      this.start_time = new Date().getTime();
      this.window_id = this.start_time;

      this._setup_context();
      this.setup_events();
    }.bind(exports),

    _setup_context: function () {
      this.ctx = {modal: $(this.options.target)};
      this.show_modal_action = this.options.show_modal_action || this.default_show_modal_action;
      this.show_modal_action.bind(exports);
    }.bind(exports),

    setup_events: function () {
      this.ctx.modal.on("shown.bs.modal", this.handle_modal_show);
      this.ctx.modal.on("hidden.bs.modal", this.handle_modal_hide);
    }.bind(exports),

    // When modal is shown, don't show modal anymore.
    handle_modal_show: function () {
      var event_name = this.ctx.modal.data("js-trigger-event");
      // mark as shown
      var time_spent = parseInt(getCookie(this.timespent_cookie_name)) || 0;
      var sync = getCookie(this.sync_cookie_name);
      // do not rewrite previously set mode from auto-trigger
      if (sync !== this.TIMER) {
        setCookie(
          this.sync_cookie_name,
          this.DISABLED,
          this.cookie_age - time_spent,
          "/"
        );
      }
      if (event_name) {
        this.track_promo_box_event(event_name);
      }
    }.bind(exports),

    handle_modal_hide: function () {
      if (this.options.on_exit_modal) this.options.on_exit_modal();
    }.bind(exports),

    has_been_shown: function () {
      var shown =
        this.trigger_states.indexOf(getCookie(this.sync_cookie_name)) !== -1;
      var is_popup_v1 = $(`#${REBATE_POPUP_MODAL_ID}`).data("version") === 1;

      if (shown || !is_popup_v1) {
        window.gb.can_collapse_promo_box = true;
      }
      return shown;
    }.bind(exports),

    // trigger modal show
    show_modal: function (event_name) {
      this.ctx.modal.data("js-trigger-event", event_name);
      this.show_modal_action(event_name);
      this.ctx.modal.trigger("modal_" + event_name);
    }.bind(exports),

    // trigger low level action to show modal
    default_show_modal_action: function () {
      this.ctx.modal.modal('show');
    }.bind(exports),

    track_promo_box_event: function (suffix) {
      const target = $(this.options.target);

      dataLayerService.retailerCashbackCodeInterationEvent({
        action: suffix,
        retailerLocation: target.data('store'),
        retailerName: target.data('retailer-slug'),
        type: 'local',
      });

    }.bind(exports),

    /* ===========================================================
     * Fires a modal after some time spent on the website.
     * Syncrhonizes time among tabs/windows opened.
     */
    show_timed_modal: function () {
      var new_time = new Date().getTime(),
        time_spent,
        access,
        elapsed = new_time - this.start_time,
        locked = getCookie(this.sync_cookie_name);

      // cookie `sync_cookie_name` is used for a poor locking mechanism
      // where critical section is code that updates the cookie.
      // this concurrent access needs to be implemented in order to keep
      // tabs/windows in sync and let a window update time spent amount as soon
      // as no other window is doing that..
      // ("as soon as" = on next timer tick).

      // means that window has been manually triggered somewhere, stop timer.
      if (locked === this.DISABLED) {
        return;
      }
      locked = parseInt(locked);
      access = !locked || locked === this.window_id;
      this.start_time = new_time;

      // lock writer
      if (access) {
        // in case tab/window gets killed/hangs, no deadlock
        // will happen since maximum time this cookie exists is 5 seconds,
        // so we lose only 5 - 2 = 3 seconds :)
        setCookie(this.sync_cookie_name, this.window_id, 5 * 1000, "/");
      }

      // add time spent to general bucket
      time_spent = parseInt(getCookie(this.timespent_cookie_name)) || 0;
      time_spent += elapsed;

      // only if we have lock, we can write this to cookie.
      if (access) {
        setCookie(
          this.timespent_cookie_name,
          time_spent,
          this.cookie_age - time_spent,
          "/"
        );
      }

      if (time_spent >= this.options.modal_timeout) {
        // fire modal
        this.show_modal("trigger_timer");
        return;
      }
      // try again later.
      setTimeout(this.show_timed_modal, 2000);
    }.bind(exports),

    // Triggers - events that trigger showing the modal.

    /* ==========================================================
     * Keeps track of time user spent on site and fires modal
     * when specified timeout elapsed.
     */
    start_timer_trigger: function () {
      if (this.has_been_shown()) {
        if (this.options.show_default) {
          this.show_modal();
        }
        return;
      }
      // 'timer' means that modal has already been shown by timer.
      setTimeout(this.show_timed_modal, 2000);
    }.bind(exports),

    /* ==========================================================
     * Fires a modal when user is about to leave the site.
     */
    start_exit_intent_trigger: function () {
      if (this.has_been_shown()) {
        return;
      }

      var oui = ouibounce(false, {
        callback: function () {
          if (exports.has_been_shown()) {
            oui.disable();
          } else {
            exports.show_modal("trigger_exit");
          }
        },
        cookieExpire: 30, // 30 days
        cookieName: '_exit_banner_triggered'
      });
    }.bind(exports),

    start_resize_trigger: function () {
      // Mobile
      var $modal = this.ctx.modal;
      var modal_dismissed = '_modal_dismissed';

      if (use_mobile_version) {
        $("#rebate-popup-mobile").on("click", function () {
          if (is_ie10_or_ie11) {
            $(this).hide();
          }
          exports.show_modal("click_maximize");
        });

        $modal.find(".feedback-toggle").on("click", () => $modal.modal('hide'));

        $modal.on("hidden.bs.modal", function () {
          exports.track_promo_box_event("click_minimize");
          window.gb.promo_box_dismissed = true;
        });

        // Desktop
      } else {
        let has_model_been_collapsed = false;

        $modal.find(".feedback-toggle").on("click", function () {
          var body = $("#rebate-modal-content"), event_name;
          body.toggleClass("collapsed");

          setCookie(modal_dismissed, 'true', window.gb.AUX_COOKIE_AGE, '/');

          event_name = "click_" + (body.hasClass("collapsed") ? "minimize" : "maximize");
          exports.track_promo_box_event(event_name);
          window.gb.promo_box_dismissed = true;
        });

        $modal.find(".modal-header").on("click", function () {
          const body = $("#rebate-modal-content");
          const isV1Popup = $(`#${REBATE_POPUP_MODAL_ID}`).data("version") === 1;
          let event_name;

          const canV1PopupBeOpened = isV1Popup && body.hasClass('collapsed');

          if (
            window.gb.promo_box_dismissed ||
            window.gb.can_collapse_promo_box ||
            canV1PopupBeOpened
          ) {
            body.toggleClass("collapsed");

            var isCollapsed = body.hasClass("collapsed");

            rebatePopupModalIcon(isCollapsed, `#${REBATE_POPUP_MODAL_ID}`, isV1Popup);

            if (!isCollapsed) {
              window.gb.promo_box_dismissed = false;
            }

            event_name =
              "click_" + (isCollapsed ? "minimize" : "maximize");
            exports.track_promo_box_event(event_name);
          } else if (!body.hasClass("collapsed")) {
            if (
              has_model_been_collapsed &&
              $modal.find(".pro-tip:visible").length
            ) {
              $modal
                .find(".btn--coupon-container")
                .effect("shake", {distance: 8});
            } else {
              $modal.find(".pro-tip").show();
              has_model_been_collapsed = true;
            }
          }
        });

        $modal.on("modal_trigger_timer", (event, event_name) => exports.track_promo_box_event("automaximize"));
      }
    }.bind(exports)
  });

  exports.init(options);
  return exports;
};


function get_latest_pageviews(count) {
  var cookie_name = "_user_pageviews";

  var get_current_pageviews = function () {
    var pages = getCookie(cookie_name);
    return pages ? pages.split(",") : [];
  };

  var pages = get_current_pageviews(), url = location.href;

  if (pages.indexOf(url) === -1) {
    pages.push(url);
  }
  pages = pages.slice(-count);
  // comma-separated list of URLs user has been on.
  setCookie(cookie_name, pages.join(","), window.gb.AUX_COOKIE_AGE, "/");
  return pages;
}

function resolve_notification_cookie(value) {
  try {
    return JSON.parse(value);
  } catch (e) {
  }
}

function setup_notification_request(pageviews) {
  let notify_cookie_name = "_user_notification",
    notify_cookie = getCookie(notify_cookie_name),
    sticky_modal = $(`#${REBATE_POPUP_MODAL_ID}`),
    has_sticky_modal = sticky_modal.length > 0,
    modal_promotion,
    modal_store;

  if (
    notify_cookie === "true" ||
    (!notify_cookie && (pageviews.length < 2 || !has_sticky_modal))
  ) {
    return;
  }

  const resolved = resolve_notification_cookie(notify_cookie);

  if (resolved) {
    (modal_promotion = resolved.promotion), (modal_store = resolved.store);
  } else if (has_sticky_modal) {
    modal_promotion = sticky_modal.data("promotion");
    modal_store = sticky_modal.data("store");
  }

  const worker_setup = ServiceWorkerSetup(getCookie("csrftoken"));
  const promise = worker_setup.init_and_subscribe({
    promotion: modal_promotion,
    store: modal_store
  });

  if (promise !== undefined) {
    promise.then(function (subscription) {
      if (worker_setup.is_push_enabled !== false) {
        setCookie(notify_cookie_name, "true", window.gb.AUX_COOKIE_AGE, "/");
      }
    });
  } else {
    setCookie(notify_cookie_name, "true", window.gb.AUX_COOKIE_AGE, "/");
  }
}

function setup_promo_box_modal() {
  const event_prefix = "local_offer", cookie_prefix = "_modal";

  PromoBoxHandler({
    target: "#promo-box-modal",
    modal_timeout: 3 * 60 * 1000,
    max_pageviews: 3,
    scroll_max_pageviews: 2,
    event_prefix: event_prefix,
    cookie_prefix: cookie_prefix
  });

  // Hook up viewing inline boxes
  $(".promo-box").not(".modal").not("#rebate-modal-content").each(function () {
    const element = $(this).find("a[data-source]");
    if (element.data("storeSlug") || element.data("retailerSlug")) {
        dataLayerService.retailerCashbackCodeInterationEvent({
        action: CashbackCodeAction.VIEW,
        retailerLocation: element.data("storeSlug"),
        retailerName: element.data("retailerSlug"),
        pageRegion: element.data("pageRegion"),
        source: new URLSearchParams(window.location.search).get("ga") || "",
        type: element.data("storeSlug") ? PromoType.LOCAL : PromoType.ONLINE,
      });
    }
  });
}


function setup_discounts_modal() {
  const event_prefix = "discounts", cookie_prefix = "_exit_modal";

  const EXIT_BANNER_OPENED_CLASS = "exit-banner-open";

  function handlePopoversOnExitModal() {
    if ($("body").hasClass(EXIT_BANNER_OPENED_CLASS)) return false;
  }

  const promo = PromoBoxHandler({
    target: "#exit-banner-modal",
    event_prefix: event_prefix,
    cookie_prefix: cookie_prefix,
    cookie_age: window.gb.AUX_COOKIE_AGE,
    show_modal_action: function () {
      $("body").addClass(`reduce-popover-zindex ${EXIT_BANNER_OPENED_CLASS}`);
      promo.ctx.modal.modal('show');
      promo.ctx.modal.find('.close-modal').on('click', function () {
        promo.ctx.modal.modal('hide');
      });

      /*
        This event listener fixes the issue with opened popovers
        when the exit modal opens.
      */
      $("[rel='popover-clickable']").on('hide.bs.popover', handlePopoversOnExitModal);
    },
    on_exit_modal: function () {
      $("body").removeClass(`reduce-popover-zindex ${EXIT_BANNER_OPENED_CLASS}`);

      $("[rel='popover-clickable']").off('hide.bs.popover', handlePopoversOnExitModal);
    }
  });

  const excludedURLs = [
    '/account/',
    '/best-local-offer/',
    '/cashback-code/',
    '/cashback/',
    '/claim-offer/',
    '/mattress-brands/',
    '/mattress-deals/',
    '/mattress-finder/',
    '/mattress-models/',
    '/mattress-reviews/',
    '/mattress-store-reviews/',
    '/rebate/',
    '/review-mattress/',
    '/review-mattress-store/',
    '/signin/',
  ];

  const is_excluded = excludedURLs.some(url => window.location.pathname.substring(0, url.length) === url);

  if (!is_excluded && promo.ctx.modal.length && !is_mobile) {
    promo.start_exit_intent_trigger();
  }
}

function onToggleModal(open) {
  $(document.body).toggleClass(REBATE_POPUP_MODAL_OPEN_CLASS, open);

  if (open) {
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';
  } else {
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }
}


function setup_rebate_code_popup(cookie_age) {
  const event_prefix = "local_offer_sticky";
  const target = `#${REBATE_POPUP_MODAL_ID}`;
  const targetBody = "#rebate-modal-content";

  // Display rules for the new sticky modal versions:
  // * https://app.asana.com/0/6443738935704/174520455141024/f
  let version = $(target).data("version");
  let timeout = {
    1: 15,
    default: 5
  };
  let modal_timeout = timeout.hasOwnProperty(version)
    ? timeout[version]
    : timeout["default"];

  // Variable prefix so we can set different rules for each sticky version.
  const cookie_prefix = "_modal_sticky_" + version;
  const promo = PromoBoxHandler({
    target: target,
    modal_timeout: modal_timeout * 1000,
    event_prefix: event_prefix,
    cookie_prefix: cookie_prefix,
    cookie_age: window.gb.AUX_COOKIE_AGE,
    automaximized_active: false,
    show_modal_action: function (event_name) {
      const is_popup_v1 = $(`#${REBATE_POPUP_MODAL_ID}`).data("version") === 1;
      let start_collapsed = true;

      // for mobile
      if (use_mobile_version) {

        // on mobile either timer or opening page afterwards
        // show the minimized version..
        if (event_name === "trigger_timer" || event_name == undefined) {
          var $popup_mobile = $("#rebate-popup-mobile");
          if (is_ie10_or_ie11 && event_name === "trigger_timer") {
            $popup_mobile.click();
          } else {
            $popup_mobile.show();
          }

          this.handle_modal_show();
        } else {
          this.ctx.modal
            .addClass("is-mobile")
            .modal({backdrop: false, keyboard: false})
            .one("shown.bs.modal", function () {
              $(document.body).addClass("modal-active");
            })
            .one("hidden.bs.modal", function () {
              onToggleModal(false);
              $(document.body).removeClass("modal-active");
            })
            .find(".modal-header")
            .addClass("d-none")
            .end();

          if (is_ie10_or_ie11) {
            this.ctx.modal
              .find(".data-dismiss")
              .removeClass("d-none")
              .on("click", function (e) {
                $("#rebate-popup-mobile").fadeIn();
              });
          }

          onToggleModal(true);
        }

        if (window.gb.can_collapse_promo_box) {
          $(`[data-can-collapse-promo], .${PROMO_CLOSE_ICON_CLASS}`).each(function () {
            $(this).addClass("visible");
          });
        }

        // for desktop
      } else {
        const modal_dismissed = getCookie("_modal_dismissed") === "true";

        if (is_popup_v1 && !modal_dismissed) {
          window.gb.can_collapse_promo_box = false;
          start_collapsed = false;
          this.automaximized_active = true;
        } else if (window.gb.can_collapse_promo_box) {
          $(`[data-can-collapse-promo], .${PROMO_CLOSE_ICON_CLASS}`).each(function () {
            $(this).addClass("visible");
          });
        }

        // if its modal shown by default on every page - no special event.
        // but if its timer - raise one more event on modal event: automaximize.
        this.ctx.modal.modal({backdrop: false, keyboard: false});

        const isCollapsed = event_name === undefined && start_collapsed;

        $(targetBody)
          .toggleClass("collapsed", isCollapsed)
          .addClass("collapsable");

          rebatePopupModalIcon(isCollapsed);
      }

      function togglePromoModalBody() {
        const promoBody = $(targetBody);
        promoBody.toggleClass("collapsed");
        const isCollapsed = promoBody.hasClass("collapsed");

        rebatePopupModalIcon(isCollapsed, `#${REBATE_POPUP_MODAL_ID}`, is_popup_v1);
      }

      $("[data-can-collapse-promo]").on('click', togglePromoModalBody)
    },
    show_default: true
  });

  if (!promo.ctx.modal.length) {
    return;
  }

  const should_ignore_path = window.location.pathname.indexOf(["/best-local-offer/"]) > -1;

  if (!should_ignore_path) {
    promo.start_resize_trigger();
    promo.start_timer_trigger();
  }

  // track "Show Code" availability.
  if ($("[data-source=sticky_modal]").length > 0 && window.fbq) {
    window.fbq("track", "Lead");
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const pageviews = get_latest_pageviews(3);
  setup_discounts_modal();
  setup_promo_box_modal();
  setup_rebate_code_popup();

  setup_notification_request(pageviews);

  // Hook up popovers that should be visible on top of modal.
  $(".promo-box-modal")
    .find('.store-policies [rel="popover"], [rel="popover-clickable"]')
    .popover({
      html: true,
      container: "body",
      delay: {hide: 150}
    });

  // Hook up toggle of "Change Location" dialog.
  $(".promo-box")
    .find('[data-js="change-location"], [data-js="cancel"]')
    .on("click", function (e) {
      $(this)
        .parents(".promo-box")
        .find('[data-js="my-location"]')
        .slideToggle();
      e.preventDefault();
    });

  // Add "collapsing" class when promo box footer is collapsing
  $(".promo-box-lg .collapsible-footer").on("show hide", function () {
    $(this).addClass("collapsing");
  });
  $(".promo-box-lg .collapsible-footer").on("shown hidden", function () {
    $(this).removeClass("collapsing");
  });

});
